// extracted by mini-css-extract-plugin
export default {"copyRight_container":"styles_copyRight_container__sK5oF","copyRight":"styles_copyRight__HMd+q","copyRight_subContainer":"styles_copyRight_subContainer__P0yy2"};